import { useMediaQuery } from 'react-responsive'
import { BR } from 'constants'

export const useBreak = ( BP = 'md_dn' ) => {
  return useMediaQuery( BR[BP] )
}